module.exports = __webpack_public_path__ + "img/40.b925695d.png";